import sliceCreator from '../../index.js';
import {RE_CALCULATE} from '../../../constants/index.js';
const _postRecaluculateAction = sliceCreator('RE_CALCULATE',RE_CALCULATE, 'post');

const { asyncAction: postRecaluculateAction, reducer, clearData: clearPostRecaluculateAction } = _postRecaluculateAction;

export default reducer;

export {
    postRecaluculateAction,
    clearPostRecaluculateAction
}


